import { useState, useRef, useEffect } from "react";
import Contexto from "./Contexto";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import ListaSedes from "./ListaSedes";
import ListaEmpleados from "./ListaEmpleados";
import ListaTiposSesion from "./ListaTiposSesion";
import ListaHorariosDisponibles from "./ListaHorariosDisponibles";
import FormDatosContacto from "./FormDatosContacto";
import ConfirmarSolicitudSesion from "./ConfirmarSolicitudSesion";
import { cargarConfig } from "../config/cargarConfig";
import { aplicarBrandingTenant } from "../config/aplicarBrandingTenant";

import {
  Cabecera,
  Pie,
  Cargando,
  excepcionVacia,
  MensajeExcepcion,
  MensajeFinal,
  llamarApi,
  logger,
  initLogger
} from "./Comun";

const SolicitudSesion = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [paso, setPaso] = useState(null);

  const [excepcion, setExcepcionInner] = useState(excepcionVacia);

  const alertRef = useRef(null);
  const fetchEjecutado = useRef(false);

   const [config, setConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      const cfg = await cargarConfig();
      setConfig(cfg);
      initLogger(cfg);
      aplicarBrandingTenant(cfg);
    };

    fetchConfig();
  }, []);


  const setExcepcion = (excepcionParam) => {
    if (!isEqual(excepcionParam, excepcion)) {

      if (excepcionParam === null || isEqual(excepcionParam, excepcionVacia)) {
        sessionStorage.removeItem("excepcion");
      } else {
        sessionStorage.setItem("excepcion", JSON.stringify(excepcionParam));
      }
    
      setExcepcionInner(cloneDeep(excepcionParam));
    }
  };

  const [contextoApp, setContextoApp] = useState(() => {
    const contextoApp_SS = sessionStorage.getItem("contextoApp");
    return contextoApp_SS ? JSON.parse(contextoApp_SS) : null;
  });

  const actualizarContextoApp = (contextoAplicacion) => {
    if (contextoAplicacion === null)
    {
      sessionStorage.removeItem("contextoApp");
    }
    else
    {
      sessionStorage.setItem(
        "contextoApp",
        JSON.stringify(contextoAplicacion)
      );
    }

   setContextoApp(contextoAplicacion);
  }

  
const jwt = useRef(null);
const idSede = useRef(null);

  const idEmpleado = useRef(null);
  const idTipoSesion = useRef(null);
  const horarioSeleccionado = useRef(null);
  const citaEsParaContacto = useRef(null);
  const nombrePaciente = useRef(null);
  const apellidosPaciente = useRef(null);
  const nombreContacto = useRef(null);
  const apellidosContacto = useRef(null);
  const telefonoContacto = useRef(null);
  const emailContacto = useRef(null);
  const esPrimeraVez = useRef(null);
  const idSolicitudSesion = useRef(null);

  const datosSolicitudSesionVacia = {
    direccionCompletaSede: null,
    fechaSolicitudSesion: null,
    horaInicio: null,
    horaFin: null,
    mensajeSolicitudSesionConfirmada: null,
  };

  const datosSolicitudSesionRegistrada = useRef(datosSolicitudSesionVacia);

  const limpiarSesion = () => {
    setIdSede(null);
    setIdEmpleado(null);
    setIdTipoSesion(null);
    setHorarioSeleccionado(null);
    setIdSolicitudSesion(null);
  };

  const [recargarContexto, setRecargarContexto] = useState(0);

  const reiniciarProceso = () => {
    if (!contextoApp)
      {
        setRecargarContexto(prev => prev + 1);
        setIsLoading(true);
      }
      else
      {
        setJwt(null);
      }
      
      setExcepcion(cloneDeep(excepcionVacia));
      setPaso("LS");
  };

  const setJwt = (jwtParam) => {
    jwt.current = jwtParam;

    if (jwtParam === null) {
      sessionStorage.removeItem("jwtLocal");
    } else {
      sessionStorage.setItem("jwtLocal", jwtParam);
    }
  };

  const setIdSede = (idSedeParam, actualizarSS = true) => {
    //if (contextoApp.multiSede !== 0 || idSede.current !== null) {
      // Si no es multisede, la sede siempre debe tener un valor
      idSede.current = idSedeParam;

      if (actualizarSS)
      {
        if (idSedeParam === null) {
          sessionStorage.removeItem("idSedeLocal");
        } else {
          logger("asigno sede " + idSedeParam);
          sessionStorage.setItem("idSedeLocal", idSedeParam);
        }
      }
  //  }
  };

  const setIdEmpleado = (idEmpleadoParam, actualizarSS = true) => {
    idEmpleado.current = idEmpleadoParam;

      if (actualizarSS)
      {    
    if (idEmpleadoParam === null) {
      sessionStorage.removeItem("idEmpleadoLocal");
    } else {
      sessionStorage.setItem("idEmpleadoLocal", idEmpleadoParam);
    }}
  };

  const setIdTipoSesion = (idTipoSesionParam, actualizarSS = true) => {
    idTipoSesion.current = idTipoSesionParam;
      if (actualizarSS)
      {
    if (idTipoSesionParam === null) {
      sessionStorage.removeItem("idTipoSesionLocal");
    } else {
      sessionStorage.setItem("idTipoSesionLocal", idTipoSesionParam);
    }}
  };

  const setHorarioSeleccionado = (horarioSeleccionadoParam, actualizarSS = true) => {
    horarioSeleccionado.current = horarioSeleccionadoParam;
if (actualizarSS)
      {
    if (horarioSeleccionadoParam === null) {
      sessionStorage.removeItem("horarioSeleccionadoLocal");
    } else {
      sessionStorage.setItem(
        "horarioSeleccionadoLocal",
        horarioSeleccionadoParam
      );
    }}
  };

    const setCitaEsParaContacto = (citaEsParaContactoParam, actualizarSS = true) => {
    citaEsParaContacto.current = citaEsParaContactoParam;
if (actualizarSS)
      {
    if (citaEsParaContactoParam === null) {
      sessionStorage.removeItem("citaEsParaContactoLocal");
    } else {
      sessionStorage.setItem("citaEsParaContactoLocal", citaEsParaContactoParam);

      logger("pongo el valor a cita es para contacto" + citaEsParaContactoParam);
    }}
  };


  const setNombrePaciente = (nombrePacienteParam, actualizarSS = true) => {
    nombrePaciente.current = nombrePacienteParam;
if (actualizarSS)
      {
    if (nombrePacienteParam === null) {
      sessionStorage.removeItem("nombrePacienteLocal");
    } else {
      sessionStorage.setItem("nombrePacienteLocal", nombrePacienteParam);

      logger("pongo el valor a nombre paciente" + nombrePacienteParam);
    }}
  };

  const setApellidosPaciente = (apellidosPacienteParam, actualizarSS = true) => {
    apellidosPaciente.current = apellidosPacienteParam;
if (actualizarSS)
      {
    if (apellidosPacienteParam === null) {
      sessionStorage.removeItem("apellidosPacienteLocal");
    } else {
      sessionStorage.setItem("apellidosPacienteLocal", apellidosPacienteParam);
    }}
  };

  const setNombreContacto = (nombreContactoParam, actualizarSS = true) => {
    nombreContacto.current = nombreContactoParam;
if (actualizarSS)
      {
    if (nombreContactoParam === null) {
      sessionStorage.removeItem("nombreContactoLocal");
    } else {
      sessionStorage.setItem("nombreContactoLocal", nombreContactoParam);
    }}
  };

  const setApellidosContacto = (apellidosContactoParam, actualizarSS = true) => {
    apellidosContacto.current = apellidosContactoParam;
if (actualizarSS)
      {
    if (apellidosContactoParam === null) {
      sessionStorage.removeItem("apellidosContactoLocal");
    } else {
      sessionStorage.setItem("apellidosContactoLocal", apellidosContactoParam);
    }}
  };

  const setTelefonoContacto = (telefonoContactoParam, actualizarSS = true) => {
    telefonoContacto.current = telefonoContactoParam;
if (actualizarSS)
      {
    if (telefonoContactoParam === null) {
      sessionStorage.removeItem("telefonoContactoLocal");
    } else {
      sessionStorage.setItem("telefonoContactoLocal", telefonoContactoParam);
    }}
  };

  const setEmailContacto = (emailContactoParam, actualizarSS = true) => {
    emailContacto.current = emailContactoParam;
if (actualizarSS)
      {
    if (emailContactoParam === null) {
      sessionStorage.removeItem("emailContactoLocal");
    } else {
      sessionStorage.setItem("emailContactoLocal", emailContactoParam);
    }}
  };

  const setEsPrimeraVez = (esPrimeraVezParam, actualizarSS = true) => {
    esPrimeraVez.current = esPrimeraVezParam;
if (actualizarSS)
      {
    if (esPrimeraVezParam === null) {
      sessionStorage.removeItem("esPrimeraVezLocal");
    } else {
      sessionStorage.setItem("esPrimeraVezLocal", esPrimeraVezParam);
    }}
  };

  const setIdSolicitudSesion = (idSolicitudSesionParam, actualizarSS = true) => {
    idSolicitudSesion.current = idSolicitudSesionParam;
if (actualizarSS)
      {
    if (idSolicitudSesionParam === null) {
      sessionStorage.removeItem("idSolicitudSesionLocal");
    } else {
      sessionStorage.setItem("idSolicitudSesionLocal", idSolicitudSesionParam);
    }}
  };

  const setDatosSolicitudSesionRegistrada = (
    datosSolicitudSesionRegistradaParam, actualizarSS = true
  ) => {
    datosSolicitudSesionRegistrada.current = datosSolicitudSesionRegistradaParam;

    if (actualizarSS)
      {
    if (datosSolicitudSesionRegistradaParam === null) {
      sessionStorage.removeItem("datosSolicitudSesionRegistradaLocal");
      datosSolicitudSesionRegistrada.current = null;
    } else {
      datosSolicitudSesionRegistrada.current.direccionCompletaSede =
        datosSolicitudSesionRegistradaParam.direccionCompletaSede;
      datosSolicitudSesionRegistrada.current.fechaSolicitudSesion =
        datosSolicitudSesionRegistradaParam.fechaSolicitudSesion;
      datosSolicitudSesionRegistrada.current.horaInicio =
        datosSolicitudSesionRegistradaParam.horaInicio;
      datosSolicitudSesionRegistrada.current.horaFin =
        datosSolicitudSesionRegistradaParam.horaFin;
      datosSolicitudSesionRegistrada.current.mensajeSolicitudSesionConfirmada =
        datosSolicitudSesionRegistradaParam.mensajeSolicitudSesionConfirmada;

      sessionStorage.setItem(
        "datosSolicitudSesionRegistradaLocal",
        JSON.stringify(datosSolicitudSesionRegistradaParam)
      );
    }}
  };

  const irAPAso = (idPaso) => {
    setPaso(idPaso);
  };

  const paginaAMostrar = () => {
    switch (paso) {
      case "LS":
        return (
          <ListaSedes
            jwt={jwt.current}
            setJwt={setJwt}
            irAPAso={irAPAso}
            setIdSede={setIdSede}
            setExcepcion={setExcepcion}
          />
        );
      case "LE":
        return (
          <ListaEmpleados
            jwt={jwt.current}
            setJwt={setJwt}          
            irAPAso={irAPAso}
            idSede={idSede.current}
            setIdSede={setIdSede}
            setIdEmpleado={setIdEmpleado}
            setExcepcion={setExcepcion}
          />
        );
      case "LTS":
        return (
          <ListaTiposSesion
            jwt={jwt.current}
            setJwt={setJwt}          
            irAPAso={irAPAso}
            idSede={idSede.current}
            idEmpleado={idEmpleado.current}
            setIdSede={setIdSede}
            setIdEmpleado={setIdEmpleado}
            setIdTipoSesion={setIdTipoSesion}
            setExcepcion={setExcepcion}
          />
        );
      case "LHD":
        return (
          <ListaHorariosDisponibles
            jwt={jwt.current}
            setJwt={setJwt}          
            irAPAso={irAPAso}
            idSede={idSede.current}
            idSolicitudSesion={idSolicitudSesion.current}
            idTipoSesion={idTipoSesion.current}
            idEmpleado={idEmpleado.current}
            setIdSede={setIdSede}
            setIdEmpleado={setIdEmpleado}
            setIdTipoSesion={setIdTipoSesion}
            setHorarioSeleccionado={setHorarioSeleccionado}
            setIdSolicitudSesion={setIdSolicitudSesion}
            setExcepcion={setExcepcion}
          />
        );
      case "FDC":
        return (
          <FormDatosContacto
            jwt={jwt.current}
            setJwt={setJwt}          
            irAPAso={irAPAso}
            idSolicitudSesion={idSolicitudSesion.current}
            citaEsParaContacto={citaEsParaContacto.current}
            nombrePaciente={nombrePaciente.current}
            apellidosPaciente={apellidosPaciente.current}            
            nombreContacto={nombreContacto.current}            
            apellidosContacto={apellidosContacto.current}
            telefonoContacto={telefonoContacto.current}
            emailContacto={emailContacto.current}
            esPrimeraVez={esPrimeraVez.current}
            setHorarioSeleccionado={setHorarioSeleccionado}
            setIdSolicitudSesion={setIdSolicitudSesion}
            setCitaEsParaContacto={setCitaEsParaContacto}
            setNombrePaciente={setNombrePaciente}
            setApellidosPaciente={setApellidosPaciente}
            setNombreContacto={setNombreContacto}
            setApellidosContacto={setApellidosContacto}
            setTelefonoContacto={setTelefonoContacto}
            setEmailContacto={setEmailContacto}
            setEsPrimeraVez={setEsPrimeraVez}
            limpiarSesion={limpiarSesion}
            reiniciarProceso={reiniciarProceso}
            setDatosSolicitudSesionRegistrada={
              setDatosSolicitudSesionRegistrada
            }
            setExcepcion={setExcepcion}            
          />
        );
      case "CSS":
        return (
          <ConfirmarSolicitudSesion
            datosSolicitudSesionRegistrada={
              datosSolicitudSesionRegistrada.current
            }
          />
        );
      case "ERR":
        return (
          <MensajeFinal
            tipo={excepcion.tipoExcepcion}
            mensaje={excepcion.mensajeExcepcion}
            infoDebug={excepcion.infoDebug}
            permitirReiniciarProceso={excepcion.permitirReiniciarProceso}
            limpiarSesion={limpiarSesion}
            reiniciarProceso={reiniciarProceso}
          />
        );
      default:
        return <></>;
      // no hacer nada
    }
  };

  logger(
    new Date().getHours() +
      ":" +
      new Date().getMinutes() +
      "." +
      new Date().getSeconds() +
      "- Render del leer parametros"
  );

  useEffect(() => {
    if (!config) return;

    if (!contextoApp)
    {
      if (fetchEjecutado.current) return;

      fetchEjecutado.current = true;

      let codigoCanalCaptacion = null;

      const URLParams = new URLSearchParams(window.location.search);

      if (
        URLParams &&
        URLParams !== "" &&
        URLParams !== "undefined" &&
        URLParams.get("cc") &&
        URLParams.get("cc") !== ""
      ) {
        codigoCanalCaptacion = URLParams.get("cc");
      }

      llamarApi({
        url: config.urlBaseApis + "lp",
        method: "GET",
        payload: { cc: codigoCanalCaptacion },
        onSuccess: (data) => {

          // Si no es multisede, asigno la que hay
          if (!data.multiSede) {
            setIdSede(data.idSede);
          }

          const contextoAplicacion = {
            urlBaseApis: config.urlBaseApis,
            //jwt: data.jwt,
            idCanalCaptacion: data.idCanalCaptacion,
            nombreClinica: data.nombreClinica,
            multiSede: data.multiSede,
            idSede: !data.multiSede ? data.idSede : null,
            idCanalCaptacion: data.idCanalCaptacion,
            empleadoSeleccionable: data.empleadoSeleccionable,
            permitirEmpleadoSinPreferencia: data.permitirEmpleadoSinPreferencia,
            idEmpleadoSinPreferencia: data.idEmpleadoSinPreferencia,
            textoErrorNoControlado: data.textoErrorNoControlado,
            textoErrorSinHorariosDisponibles: data.textoErrorSinHorariosDisponibles
          };

          setJwt(data.jwt);
          actualizarContextoApp(contextoAplicacion);
        },
          onError: (err) => setExcepcion(err),
          onFinally: () => {fetchEjecutado.current = false; setIsLoading(false)},
        });
      } // No tengo que lanzar la api
      else {
        setIsLoading(false);
      }
  }, [config, recargarContexto]);

  useEffect(() => {
    if (!isEqual(excepcion, excepcionVacia) && alertRef.current) {
      const headerHeight = 80; // adjust to your actual navbar height
      const elementPosition =
        alertRef.current.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerHeight;
      logger("subo al " + offsetPosition);
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }, [excepcion]);

  if (isLoading || !config) return <Cargando mensaje="Cargando ..."></Cargando>;

  logger("Voy a comprobar el paso, y paso es el ..." + paso);

  if (
    (excepcion === null || isEqual(excepcion, excepcionVacia)) &&
    sessionStorage.getItem("excepcion") !== null &&
    !isEqual(sessionStorage.getItem("excepcion"), excepcion)
  ) {

    setExcepcion(JSON.parse(sessionStorage.getItem("excepcion")), false);
    logger("EXcepcion asignada a excepcion global");
  }

  logger("la excepcion es str" + JSON.stringify(excepcion));

  if (paso != "ERR") {
    if (
      excepcion !== null &&
      !isEqual(excepcion, excepcionVacia) &&
      !excepcion.continuarEnPagina
    ) {
      setPaso("ERR");
    } else {
        if (!jwt.current && sessionStorage.getItem("jwtLocal")) {
          setJwt(sessionStorage.getItem("jwtLocal"));
        }

      if (paso !== null) {
        // Si voy a ir a la lista de sedes pero solo hay una sede, voy directo a la lista de tipos de sesion
        if (contextoApp && contextoApp.multiSede === 0 && paso === "LS" && idSede !== null) {
          setPaso("LTS");
        } else if (paso === "LE" && contextoApp.empleadoSeleccionable === 0) {
          //Esto no debería ocurrir, porque no le puedo mandar a la lista de empleados si no lo permite el sistema, pero por si acaso
          if (idSede !== null) {
            setPaso("LTS");
          } else {
            setPaso("LS");
          }
        }
      } // // Determino la pagina a mostrar en funcion de lo que haya en la sesion. Si no esta ni la sede, no sigo buscando el resto de variables
      else {
        if (sessionStorage.getItem("idSedeLocal")) {
          setIdSede(sessionStorage.getItem("idSedeLocal"), false);

          if (sessionStorage.getItem("idEmpleadoLocal")) {
            setIdEmpleado(sessionStorage.getItem("idEmpleadoLocal"), false);
          }
          if (sessionStorage.getItem("idTipoSesionLocal")) {
            setIdTipoSesion(sessionStorage.getItem("idTipoSesionLocal"), false);
          }
          if (sessionStorage.getItem("horarioSeleccionadoLocal")) {
            setHorarioSeleccionado(
              sessionStorage.getItem("horarioSeleccionadoLocal"), false
            );
          }
          if (sessionStorage.getItem("idSolicitudSesionLocal")) {
            setIdSolicitudSesion(
              sessionStorage.getItem("idSolicitudSesionLocal"), false
            );
          }

          if (sessionStorage.getItem("citaEsParaContactoLocal")) {
            setCitaEsParaContacto(sessionStorage.getItem("citaEsParaContactoLocal"), false);
          }

          if (sessionStorage.getItem("nombrePacienteLocal")) {
            setNombrePaciente(sessionStorage.getItem("nombrePacienteLocal"), false);
          }

          if (sessionStorage.getItem("apellidosPacienteLocal")) {
            setApellidosPaciente(
              sessionStorage.getItem("apellidosPacienteLocal"), false
            );
          }

          if (sessionStorage.getItem("nombreContactoLocal")) {
            setNombreContacto(sessionStorage.getItem("nombreContactoLocal"), false);
          }

          if (sessionStorage.getItem("apellidosContactoLocal")) {
            setApellidosContacto(
              sessionStorage.getItem("apellidosContactoLocal"), false
            );
          }

          if (sessionStorage.getItem("telefonoContactoLocal")) {
            setTelefonoContacto(
              sessionStorage.getItem("telefonoContactoLocal"), false
            );
          }

          if (sessionStorage.getItem("emailContactoLocal")) {
            setEmailContacto(sessionStorage.getItem("emailContactoLocal"), false);
          }

          if (sessionStorage.getItem("esPrimeraVezLocal")) {
            setEsPrimeraVez(sessionStorage.getItem("esPrimeraVezLocal"), false);
          }

          if (sessionStorage.getItem("datosSolicitudSesionRegistradaLocal")) {
            setDatosSolicitudSesionRegistrada(JSON.parse(
              sessionStorage.getItem("datosSolicitudSesionRegistradaLocal")), false
            );
          }
        }

        if (
          idSolicitudSesion.current !== null &&
          horarioSeleccionado.current !== null
        ) {
          if (
            datosSolicitudSesionRegistrada.current !== null &&
            !isEqual(
              datosSolicitudSesionRegistrada.current,
              datosSolicitudSesionVacia
            )
          ) {
            setPaso("CSS");
          } else {
            setPaso("FDC");
          }
        } else if (horarioSeleccionado.current !== null) {
          // No debería ocurrir que tenga horario y no id de solicitud, pero por si acaso, le mando de nuevo a seleccionar horario
          setPaso("LHD");
        } else if (idTipoSesion.current !== null) {
          setPaso("LHD");
        } else if (idEmpleado.current !== null) {
          setPaso("LTS");
        } else {
          if (contextoApp.empleadoSeleccionable === 0) {
            if (idSede.current !== null) {
              setPaso("LTS");
            } else {
              setPaso("LS");
            }
          } else {
            if (idSede.current !== null) {
              setPaso("LE");
            } else {
              setPaso("LS");
            }
          }
        }
      }
    }
  } // De si el paso es error

  logger(
    "Sede:" +
      idSede.current +
      "---" +
      new Date().getHours() +
      ":" +
      new Date().getMinutes() +
      "." +
      new Date().getSeconds() +
      "- Antes del return de render del solicitud sesion, paso: " +
      paso
  );

  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <Cabecera config={config}></Cabecera>
        {excepcion !== null &&
          !isEqual(excepcion, excepcionVacia) &&
          excepcion.continuarEnPagina != 1 && (
            <MensajeFinal
              mostrarInfoDebug={config.mostrarInfoDebug}
              tipo={excepcion.tipoExcepcion}
              titulo={excepcion.tituloExcepcion}
              mensaje={excepcion.mensajeExcepcion}
              infoDebug={excepcion.infoDebug}
              permitirReiniciarProceso={excepcion.permitirReiniciarProceso}
              limpiarSesion={limpiarSesion}
              reiniciarProceso={reiniciarProceso}
            ></MensajeFinal>
          )}
        {excepcion !== null &&
          !isEqual(excepcion, excepcionVacia) &&
          excepcion.continuarEnPagina == 1 && (
            <MensajeExcepcion
              mostrarInfoDebug={config.mostrarInfoDebug}
              tipo={excepcion.tipoExcepcion}
              titulo={excepcion.tituloExcepcion}
              mensaje={excepcion.mensajeExcepcion}
              infoDebug={excepcion.infoDebug}
              alertRef={alertRef}
              setExcepcion={setExcepcion}
            ></MensajeExcepcion>
          )}
        {(excepcion === null ||
          isEqual(excepcion, excepcionVacia) ||
          !!excepcion.continuarEnPagina) && (
          <>
            <Contexto.Provider value={contextoApp}>
              {paso !== null ? paginaAMostrar() : ""}
            </Contexto.Provider>
          </>
        )}
        <Pie config={config}></Pie>
      </div>
    </>
  );
};
export default SolicitudSesion;
